/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react";
import Helmet from "react-helmet";
import { useStaticQuery } from "gatsby";
import { jsx as _jsx } from "react/jsx-runtime";

function SEO(_ref) {
  var description = _ref.description,
      lang = _ref.lang,
      meta = _ref.meta,
      title = _ref.title;

  var _useStaticQuery = useStaticQuery("3000541721"),
      site = _useStaticQuery.site;

  var metaDescription = description || site.siteMetadata.description;
  return /*#__PURE__*/_jsx(Helmet, {
    htmlAttributes: {
      lang: lang
    },
    title: title,
    titleTemplate: "%s",
    meta: [{
      name: "description",
      content: metaDescription
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: metaDescription
    }, {
      property: "og:type",
      content: "website"
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:title",
      content: title
    }, {
      name: "twitter:description",
      content: metaDescription
    }].concat(meta)
  });
}

SEO.defaultProps = {
  lang: "en",
  meta: [],
  description: ""
};
export default SEO;